export default __webpack_public_path__ + "static/media/igtv-icon.2c122f47.svg";